import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import Row from "react-bootstrap/esm/Row";
import { toast } from "react-hot-toast";

function Board(props) {
  const [board, setBoard] = useState([
    {
      number: -1,
      location: -1,
    },
  ]);
  const letterArray = ["B", "I", "N", "G", "O"];

  const findDuplicateValues = (number) => {
    let dupFound = 0;
    for (let i = 0; i < board.length; i++) {
      if (number === board[i].number) {
        dupFound = 1;
      }
    }
    return dupFound;
  };

  useEffect(() => {
    if (board.length > 1) {
      props.setBoard(board);
      props.setSelectionFlag(true);
      props.setCheckCard(true);
    }
  }, [board]);

  const genNewNumber = () => {
    if (props.readyToGen === true) {
      let number = -1;
      let location = -1;
      let newGen = {
        number: -1,
        location: -1,
      };
      let dup = 0;
      do {
        location = -1;
        if (location === -1) {
          location = Math.floor(Math.random() * 5);
        }
        if (location > -1 && location < 5) {
          if (location === 0) {
            number = Math.floor(Math.random() * 15 + 1);
          } else {
            number = Math.floor(Math.random() * 15 + 15 * location);
          }
        }
        dup = findDuplicateValues(number);
        if (number === props.freeNum) {
          dup = 1;
        }
      } while (dup === 1);

      newGen.number = number;
      newGen.location = location;
      setBoard((prev) => [...prev, newGen]);
      props.setReadyToGen(false);
    }
  };

  useEffect(() => {
    if (props.readyToGen === true) {
      genNewNumber();
    }
  }, [props.readyToGen]);

  return (
    <>
      <Card style={{ margin: "5px" }}>
        <div style={{ padding: "20px", fontFamily: "Roboto" }}>
          {board.map((obj, x) => {
            if (x + 1 === board.length) {
              return (
                <p
                  style={{ fontSize: "25px", color: "#1697bf" }}
                  key={Math.random()}
                >
                  <Row key={Math.random()}>
                    New Ball:
                    <div
                      key={'board' + x}
                      style={{
                        borderRadius: "100%",
                        width: "75px",
                        height: "75px",
                        paddingLeft: "18px",
                        paddingTop: "18px",
                        boxShadow: "#2a4399 -13px -17px 10px 0px inset",
                        color: "white",
                        backgroundColor: "#456fff",
                        margin: "auto",
                      }}
                    >
                      {letterArray[obj.location] &&
                        letterArray[obj.location] + obj.number}
                    </div>
                  </Row>
                </p>
              );
            }
          })}
          History of Called Balls: <br />
          {board.map((obj, x) => {
            if (x + 1 === board.length) {
              return;
            }
            if (obj.number > -1) {
              return letterArray[obj.location] + obj.number + ", ";
            }
          })}
        </div>
      </Card>
    </>
  );
}

export default Board;
